import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import Tabs, { Tab, TabContent, TabName } from '@components/Tabs';

import { fetchActiveAgencies } from '@actions/agency';

import { entitySectionPartialURL, violationTypesPartialURL } from '../AdminApp';

import EntityListing from './EntityListing';
import ViolationTypesListing from './ViolationTypesListing';

enum ActiveTab {
  VIOLATION_TYPE,
  ENTITY_SECTION,
}

interface IManagementToolsProps extends RouteComponentProps<{}> {
  // from redux
  fetchActiveAgencies: TFetchActiveAgencies;
}

interface IManagementToolsState {
  activeTab: ActiveTab;
}

class ManagementTools extends React.Component<IManagementToolsProps, IManagementToolsState> {
  constructor(props: IManagementToolsProps) {
    super(props);

    this.state = {
      activeTab: ActiveTab.VIOLATION_TYPE,
    };
  }

  componentDidMount() {
    const isPathEntitySection = this.props.location.pathname.includes(entitySectionPartialURL);

    this.props.fetchActiveAgencies();

    this.setState({
      activeTab: isPathEntitySection ? ActiveTab.ENTITY_SECTION : ActiveTab.VIOLATION_TYPE,
    });
  }

  componentWillReceiveProps(nextProps: IManagementToolsProps) {
    const hasPathChanged = nextProps.location.pathname !== this.props.location.pathname;

    if (hasPathChanged) {
      const isPathEntitySection = nextProps.location.pathname.includes(entitySectionPartialURL);

      this.setState({
        activeTab: isPathEntitySection ? ActiveTab.ENTITY_SECTION : ActiveTab.VIOLATION_TYPE,
      });
    }
  }

  onViolationTypeTabClick = () => {
    this.props.history.push(violationTypesPartialURL);
  };

  onEntitySectionTabClick = () => {
    this.props.history.push(`${entitySectionPartialURL}`);
  };

  render() {
    return (
      <Tabs activeTab={this.state.activeTab}>
        <Tab onClick={this.onViolationTypeTabClick}>
          <TabName>Violation Types</TabName>
          <TabContent>
            <ViolationTypesListing />
          </TabContent>
        </Tab>
        <Tab onClick={this.onEntitySectionTabClick}>
          <TabName>Entities</TabName>
          <TabContent>
            <EntityListing />
          </TabContent>
        </Tab>
      </Tabs>
    );
  }
}

const mapStateToProps = (state: IReduxStore) => ({});

const mapDispatchToProps = (dispatch: any) => ({
  fetchActiveAgencies: () => dispatch(fetchActiveAgencies()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManagementTools));
